module.exports = __webpack_public_path__ + "static/norquestLogo-5d7a29fae55c0219426299e281d1471d.png";